import { reactive, ref, toRaw } from "vue";
import {
  firstCreateInfoWindow,
  CreateEditAndDetail,
} from "../testPathComponents/createInfoWindow.js";
import avgPoint from "../../../utils/avgPoint";
export function drawPolygonAndLine(
  CoveringTool,
  drawType,
  mousetool,
  map,
  cancelInfoWindow,
  drawPloygonCache,
  showModal,
  modalForm,
  ext_id,
  showDetailModal,
  polyEditor,
  Covering,
  sourcePolygon,
  findIndex,
  polylineEditor,
  targetPoly
) {
  console.log(drawType);
  //   let ext_id = ref(0);
  let sign = reactive([]); // 每一个新画的框的坐标标识
  //   let targetPoly = ref([]); // 保存编辑前的原始坐标点
  const drawing = () => {
    // 使用鼠标工具
    mousetool.value.on("draw", (e) => {
      console.log(e, "绘制完成");

      // 绘画完成保存至json
      let target = []; // 覆盖物的坐标集合
      let avgPoints = []; // 用于计算中心点坐标的集合
      // let sign = [];    // 用于区分每个框及线的坐标的集合

      e.obj.getPath().forEach((item) => {
        target.push({ lng: item.lng, lat: item.lat });
        avgPoints.push({
          lon: Number(item.lng.toFixed(7)),
          lat: Number(item.lat.toFixed(7)),
        });
        // sign.push({ lon: Number(item.lng.toFixed(7)) * (10 ** 7), lat: Number(item.lat.toFixed(7)) * (10 ** 7) })
        sign.push({
          lon: Number(item.lng.toFixed(7)) * 10 ** 7,
          lat: Number(item.lat.toFixed(7)) * 10 ** 7,
        });
      });
      console.log(avgPoints);
      //       // 中心点坐标
      let position = avgPoint(avgPoints);

      // 获取绘制覆盖物的路径点
      let path = JSON.parse(JSON.stringify(target));
      if (drawType.value == "polygon") {
        // 判断是否是框绘制，如是则点要闭环
        path.push(target[0]);
      }
      path.forEach((item, i) => {
        path[i] = [item.lng, item.lat];
      });

      // 设置绘制覆盖物的属性
      e.obj.setExtData(ext_id.value + 1);
      // 框绘制完成的处理
      //   if (drawType.value == "polygon") {
      console.log(e.obj);
      // 绘制框的infowindow
      let polygonInfo = polygonInfoWindow(target[target.length - 1], e.obj);
      polygonInfo.open(map.value);
      cancelInfoWindow(() => {
        map.value.remove(polygonInfo);
      });
      mousetool.value.close(false); // 停止绘制
      // 绘制框的取消事件
      let polyCancel = document.getElementById("poly-cancel-btn");
      polyCancel.addEventListener("click", () => {
        map.value.remove(e.obj);
        map.value.remove(polygonInfo);
      });

      // 绘制框的完成事件
      let polyFinish = document.getElementById("poly-finish-btn");
      polyFinish.addEventListener("click", () => {
        map.value.remove(polygonInfo);
        console.log(sign[ext_id.value]);
        // e.obj.pointsList = JSON.parse(JSON.stringify(sign[ext_id.value])); // 用于标记每个绘制完成的框
        drawPloygonCache.value.push(e.obj); // 存储已绘制的框
        console.log(drawPloygonCache.value);
        // 绘制框的modal
        showModal("新增", drawPloygonCache.value, e.obj);

        targetPoly.value = []; // 原始坐标数据初始化为空
        e.obj
          .getPath()
          .forEach((item) => targetPoly.value.push([item.lng, item.lat])); // 存储原始框的坐标数据
        console.log(targetPoly.value);
      });

      // 所绘制区域的点击事件
      e.obj.on("click", (i) => {
        console.log(i);
        console.log(modalForm.value);
      });

      // 所绘制区域右键的点击事件
      e.obj.on("click", (i) => {
        console.log(123);
        console.log(i);
        // 绘制框的infowindow
        let editAndDetail = editAndDetailInfoWindow(
          target[target.length - 1],
          e.obj
        );
        editAndDetail.open(map.value);
        mousetool.value.close(false); // 停止绘制

        // 右键绘制框的编辑事件
        let polyEdit = document.getElementById("edit-right-btn");
        polyEdit.addEventListener("click", () => {
          // 编辑框的modal
          showModal("编辑", drawPloygonCache.value, e.obj);
          targetPoly.value = []; // 原始坐标数据初始化为空
          e.obj
            .getPath()
            .forEach((item) => targetPoly.value.push([item.lng, item.lat])); // 存储原始框的坐标数据
          console.log(targetPoly.value);

          map.value.remove(editAndDetail); // 关闭infowindow
          //   createPolyEditor(e.obj)  // 框编辑
          console.log(ext_id.value);

          console.log(e.obj);

          // if (e.obj.className === "Overlay.Polygon") {
          //   createPolyEditor(e.obj); // 框编辑
          // } else {
          //   createPolyLine(e.obj); // 线编辑
          // }
          
        });

        // 右键绘制框的详情事件
        let polyDetail = document.getElementById("detail-right-btn");
        polyDetail.addEventListener("click", () => {
          // 编辑框的modal
          showDetailModal(e.obj);
          map.value.remove(editAndDetail); // 关闭infowindow
          console.log(ext_id.value);
        });
      });
      //   }
    });
  };

  // 创建多边形编辑器
  const createPolyEditor = (overlay) => {
    // 实例化编辑对象
    polyEditor.value = new window.AMap.PolyEditor(map.value, overlay);
    // 添加编辑吸附的框
    polyEditor.value.addAdsorbPolygons(Covering.value);
    // 开始编辑
    polyEditor.value.open();
    // 调整节点事件
    polyEditor.value.on("adjust", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
    // 增加节点事件
    polyEditor.value.on("addnode", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
    // 删除节点事件
    polyEditor.value.on("removenode", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
  };

  // 框编辑和编辑的坐标处理
  const editPolygon = (overlay) => {
    sourcePolygon.value = polyEditor.value.getTarget();

    // 改变坐标
    dataSouce();

    console.log(sourcePolygon.value._opts.path);
    // console.log(modalForm.value);
  };

  // 保存框编辑
  const polygonSave = () => {
    console.log(sourcePolygon.value);
    polyEditor.value ? polyEditor.value.close() : null;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 恢复框编辑前的状态
  const polygonReset = () => {
    console.log(sourcePolygon.value);
    polyEditor.value ? polyEditor.value.close() : null;
    sourcePolygon.value
      ? sourcePolygon.value.setPath(toRaw(targetPoly.value))
      : modalForm.value[findIndex.value].path;

    //   数据赋值
    dataSouce();
    sourcePolygon.value = null;
  };

  //   数据赋值
  const dataSouce = () => {
    modalForm.value[findIndex.value].path = sourcePolygon.value
      ? sourcePolygon.value._opts.path
      : modalForm.value[findIndex.value].path;
  };

  // 创建线编辑器
  const createPolyLine = (overlay) => {
    polylineEditor.value = new window.AMap.PolylineEditor(map.value, overlay);
    polylineEditor.value.open();

    polylineEditor.value.on("adjust", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
    // 增加节点事件
    polylineEditor.value.on("addnode", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
    // 删除节点事件
    polylineEditor.value.on("removenode", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
  };

  // 线编辑和编辑的坐标处理
  const editPolyLine = () => {
    sourcePolygon.value = polylineEditor.value.getTarget();
    // 改变坐标
    dataSouce();
    console.log(sourcePolygon.value._opts.path);
  };

  // 保存线编辑
  const polyLineSave = () => {
    polylineEditor.value ? polylineEditor.value.close() : null;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 恢复线编辑前的状态
  const polyLineReset = () => {
    polylineEditor.value ? polylineEditor.value.close() : null;
    sourcePolygon.value
      ? sourcePolygon.value.setPath(toRaw(targetPoly.value))
      : modalForm.value[findIndex.value].path;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 绘制框完成的 infowindow
  const polygonInfoWindow = (position, e) => {
    console.log(e);

    var btn = `<div class="bot-btn">
    <div class="btn blue" id="poly-finish-btn">完成绘制</div>
           <div class="btn" id="poly-cancel-btn">取消绘制</div>
        </div>`;
    var infowindow = new window.AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: firstCreateInfoWindow(btn),
      offset: new window.AMap.Pixel(16, -15),
      position: [position.lng, position.lat],
    });
    return infowindow;
  };

  // 右键 绘制框 （编辑、详情）
  const editAndDetailInfoWindow = (position, e) => {
    var btn = `<div class="bot-btn">
    <div class="btn blue" id="edit-right-btn">编辑</div>
           <div class="btn" id="detail-right-btn">详情</div>
        </div>`;
    var infowindow = new window.AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: CreateEditAndDetail(btn),
      offset: new window.AMap.Pixel(16, -15),
      position: [position.lng, position.lat],
    });
    return infowindow;
  };

  return {
    drawing,
    polygonReset,
    polygonSave,
    polyLineSave,
    polyLineReset,
  };
}
